/********************* 通用函数 *********************/
import {FILEEXT_image} from "@/utils/dict/File";
export default class $utils {
    /**
     * 判断是否为IE浏览器
     * @returns {boolean}
     */
    static isIE() {
        if (!!window.ActiveXObject || 'ActiveXObject' in window) return true
        else return false
    }
    /**
     * 获取溢出文本
     * @returns {width, height}
     */
    static getEllipsisText(string, fontSize = 12, maxWidth, width) {
        let miniStr = string;
        let start = string.length - parseInt((maxWidth / width) * string.length);
        let startWidth = this.getTextSize(string.substring(start), fontSize).width;
        if (startWidth >= maxWidth) {
            while (this.getTextSize(string.substring(start), fontSize).width >= maxWidth) {
                start = start + 1;
            }
            miniStr = string.substring(start);
        } else {
            while (this.getTextSize(string.substring(start), fontSize).width < maxWidth) {
                start = start - 1;
            }
            miniStr = string.substring(start + 1);
        }
        return miniStr;
    }
    /**
     * 获取文本尺寸
     * @returns {width, height}
     */
    static getTextSize(text, fontSize = 12, widthLimit, lineHeight) {
        let span =
            this.getTextSize.span ||
            (this.getTextSize.span = document.createElement('span'));
        span.style.display = 'inline-block';
        span.style.visibility = 'hidden';
        span.style.fontSize = `${fontSize}px `;
        span.style.fontFamily = 'microsoft yahei';
        span.style.lineHeight = lineHeight ? `${lineHeight}px` : '1em';
        if (widthLimit) {
            span.style.maxWidth = `${widthLimit}px `;
        }
        span.innerText = text;
        document.body.appendChild(span);
        let {
            width,
            height
        } = span.getBoundingClientRect();
        span.remove();
        return {
            width,
            height
        };
    }
    // 获取文字长度
    static getTextWidth(text, fontSize = 12) {
        let canvas = this.checkShowTooTip.canvas || (this.checkShowTooTip.canvas = document.createElement('canvas'));
        let context = canvas.getContext('2d');
        context.font = `${fontSize}px microsoft yahei`
        let metrics = context.measureText(text)
        return metrics.width
    }
    /**
     * 判断多行文字是否需要tooltip
     * @returns {boolean}
     */
    static checkShowTooTip(text, fontSize, widthLimit, lineHeight, lineLimit = 1) {
        let {
            width,
            height,
        } = this.getTextSize(text, fontSize, widthLimit, lineHeight);
        console.log(widthLimit, width,height / lineHeight, lineLimit)
        return width < widthLimit && height / lineHeight <= lineLimit;
    }
    /**
     * 格式化时间
     * @returns {string}
     */
    static formatDate(val, format) {
        if (!val) return '';
        let time = +val ? val : val.replace(/-/g, '/')
        let date = new Date(time)
        if (/(y+)/.test(format)) {
            format = format.replace(
                RegExp.$1,
                (date.getFullYear() + '').substr(4 - RegExp.$1.length)
            )
        }
        let o = {
            'M+': date.getMonth() + 1,
            'd+': date.getDate(),
            'H+': date.getHours(),
            'm+': date.getMinutes(),
            's+': date.getSeconds(),
        }
        for (let k in o) {
            if (new RegExp(`(${k})`).test(format)) {
                let str = o[k] + ''
                format = format.replace(
                    RegExp.$1,
                    RegExp.$1.length === 1 ? str : this.padLeftZero(str)
                )
            }
        }
        return format
    }
    /**
     * 倒计时
     * @returns {string}
     */
    static formatClock(dynamicTime) {
        let time = null;
        /**
         规则如下：
         1)	当小于等于1分钟时，单位精确到秒（用s表达）；
         2)	当小于等于1小时时，单位精确到分钟（用min表达）；
         3)	当大于1小时时，以0.5小时为单位累加计算（用h表达）；
         **/
        if (dynamicTime > 60 * 60) {
            time = Math.ceil(dynamicTime / (60 * 30)) / 2 + ' h';
        } else if (dynamicTime >= 60) {
            time = Math.ceil(dynamicTime / 60) + ' min';
        } else if (dynamicTime > 0) {
            time = dynamicTime + ' s';
        } else {
            time = 1 + ' s'
        }
        return time;
    }
    /**
     * 文件大小
     * @returns {string}
     */
    static formatFileSize(fileSize) {
        if (!fileSize) return '';
        let unit = ['B', 'KB', 'MB', 'GB'];
        let unitIdx = 0;
        let sizeNum = fileSize;
        while (sizeNum >= 1024) {
            sizeNum = sizeNum / 1024;
            unitIdx++;
        }
        return `${parseFloat(sizeNum).toFixed(2)}${unit[unitIdx]}`;
    }
    /**
     * 位移
     * @returns
     */
    static elementTranslate(dom, to, from, time = 200) {
        let targetLeft = isNaN(to.left) ? to.left : `${to.left}px`;
        let targetTop = isNaN(to.top) ? to.top : `${to.top}px`;
        let parentDom = dom.offsetParent || document.body;
        let parentWidth = parentDom.clientWidth;
        let parentHeight = parentDom.clientHeight;
        if (`${to.left}`.indexOf('%')) {
            to.left = parentWidth * parseFloat(to.left) / 100;
        }
        if (`${to.top}`.indexOf('%')) {
            to.top = parentHeight * parseFloat(to.top) / 100;
        }
        if (`${from.left}`.indexOf('%')) {
            from.left = parentWidth * parseFloat(from.left) / 100;
        }
        if (`${from.top}`.indexOf('%')) {
            from.top = parentHeight * parseFloat(from.top) / 100;
        }
        to.left = parseFloat(to.left);
        to.top = parseFloat(to.top);
        from.left = parseFloat(from.left);
        from.top = parseFloat(from.top);
        let stepX = ((to.left - from.left) * 10) / time;
        let stepY = ((to.top - from.top) * 10) / time;
        let timer = setInterval(() => {
            let {
                offsetLeft,
                offsetTop
            } = dom;
            let isXOver = stepX > 0 ? offsetLeft >= to.left : offsetLeft <= to.left;
            let isYOver = stepY > 0 ? offsetTop >= to.top : offsetTop <= to.top;
            if (isXOver || isYOver) {
                clearInterval(timer);
                dom.style.left = targetLeft;
                dom.style.top = targetTop;
                dom.style.right = 'unset';
                dom.style.bottom = 'unset';
            } else {
                dom.style.left = stepX + offsetLeft + 'px';
                dom.style.top = stepY + offsetTop + 'px';
                dom.style.right = 'unset';
                dom.style.bottom = 'unset';
            }
        }, 10);
    }
    static uuid() {
        let s = []
        let hexDigits = '0123456789abcdef'
        for (let i = 0; i < 36; i++) {
            s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1)
        }
        s[14] = '4' // bits 12-15 of the time_hi_and_version field to 0010
        s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1) // bits 6-7 of the clock_seq_hi_and_reserved to 01
        s[8] = s[13] = s[18] = s[23] = '-'

        let uuid = s.join('')
        return uuid
    }

    static arrToMap(arr, proto){
        let m = new Map();
        arr.forEach(i =>{
            m.set(i[proto], i);
        })
        return m
    }
    /**
     * 获取URL参数
     * @param url
     * @param variable
     * @returns {boolean|*}
     */
    static getQueryVariable(variable, url) {
        url = url || window.location.href;
        let query = url.split('?')[1] || ''
        let vars = query.split('&')
        for (let i = 0; i < vars.length; i++) {
            let pair = vars[i].split('=')
            if (pair[0] == variable) {
                return pair[1]
            }
        }
        return false
    }
    static getFileExtension(filename) {
        const regex = /(?:\.([^.]+))?$/;
        return regex.exec(filename)[1] ? regex.exec(filename)[1].toLowerCase() : '';
    }

    static clipboard(text) {
        this.clipboard.inputEle = this.clipboard.inputEle || document.createElement('input');
        this.clipboard.inputEle.value = text;
        this.clipboard.inputEle.className = 'clipboard-input';
        document.body.appendChild(this.clipboard.inputEle);
        this.clipboard.inputEle.select();
        document.execCommand('Copy');
        this.clipboard.inputEle.remove();
    }

    static guid() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            let r = (Math.random() * 16) | 0,
                v = c == 'x' ? r : (r & 0x3) | 0x8
            return v.toString(16)
        })
    }

    static downloadFileByUrl(url, fileName) {
        if (fileName) {
            const x = new XMLHttpRequest();
            x.open('GET', url, true);
            x.responseType = 'blob';
            x.onload = () => {
              const url = window.URL.createObjectURL(x.response);
              const a = document.createElement('a');
              a.href = url;
              a.download = fileName;
              a.target = '_blank';
              a.click();
            }
            x.send();
        } else {
            this.downloadFileByUrl.frameEle = this.downloadFileByUrl.frameEle || document.createElement('iframe');
            if (document.querySelector('.download-iframe')) {
                this.downloadFileByUrl.frameEle.remove();
            }
            this.downloadFileByUrl.frameEle.src = url;
            this.downloadFileByUrl.frameEle.className = 'download-iframe';
            document.body.appendChild(this.downloadFileByUrl.frameEle);
            setTimeout(() => {
                this.downloadFileByUrl.frameEle.remove();
            }, 500);
        }
    }

    static debounce(fn, wait = 500, immediate = false){
        let timeout = null;
        let flag = true;
        return function(...args) {
            let context = this;
            clearTimeout(timeout);
            if (immediate) {
                if(flag){
                    fn.apply(context, args);
                    flag = false;
                }
                timeout = setTimeout(function(){
                    flag = true;
                }, wait);
            } else {
                timeout = setTimeout(function(){
                    fn.apply(context, args);
                }, wait);
            }
        }
    }

    static throttle(func, wait = 500, immediate = true) {
        let lastTime = immediate ? null : +new Date();
        let timeout;
        return function(...args){
            let context = this;
            let now = +new Date();
            if (lastTime && now < lastTime + wait) {
                if (timeout) {
                    clearTimeout(timeout);
                    timeout = null;
                }
                timeout = setTimeout(() => {
                    lastTime = now;
                    func.apply(context, args);
                }, wait);
            } else {
                lastTime = now;
                func.apply(context, args);
            }
        };
    };
    static checkShowToolTipForMultiLine(e, t, i, o, s) {
        let r = this.checkShowTooTip.span || (this.checkShowTooTip.span = document.createElement("span"));
        r.style.display = "inline-block",
            r.style.visibility = "hidden",
            r.style.font = t,
            r.style.lineHeight = i + "px",
            r.innerText = e,
            document.body.appendChild(r);
        let {width: n, height: a} = r.getBoundingClientRect();
        return r.remove(),
        n < o && a / i <= s
    };
    /**
     * sleep（异步）, 如想同步请调用时使用 async/await
     * @author CHO
     * @param context 上下文/函数名
     * @param context[target] Boolean 为true放行
     * @param target String 属性名
     * @param isAsync Boolean 是否异步等待 true异步， false同步（线程等待）
     * @param upperLimit Number 最大等待时长，不建议超过2000ms， 限制3000ms
     * */
    static sleepByAsync(context, target, upperLimit = 2000) {
        const isFn = typeof context === 'function'
        if (!context || !(typeof context === 'object' || isFn)) {
            return console.error(
                'utils.sleepByAsync：context 数据类型仅支持引用型， 不能是：' + typeof context
            )
        } else if (!isFn && !(typeof target === 'string')) {
            return console.error(
                'utils.sleepByAsync：target 数据类型仅支持String， 不能是：' + typeof target
            )
        }
        //wait start
        return new Promise((res, rej) => {
            try {
                if (isFn ? context(target) : context[target]) {
                    return res(true)
                }
                const _interval = 50 // 检测间隔ms
                let _time = 0 // 计数
                const _nul = isNaN(Number(upperLimit)) ? 2000 : Number(upperLimit)
                const _ul = _nul > 5000 ? 5000 : _nul
                // while (!(isFn ? context(target) : context[target]) && _time < (_ul / _interval)) {
                //     await new Promise(resolve => {
                //         const _sto = setTimeout(() => {
                //             clearTimeout(_sto)
                //             resolve()
                //             _time++
                //         }, _interval)
                //     })
                // }
                // if (!(isFn ? context(target) : context[target])) {
                //     res(false)
                // } else {
                //     res(true)
                // }
                const _stv = setInterval(() => {
                    if (!(isFn ? context(target) : context[target]) && _time < _ul / _interval) {
                        _time++
                    } else {
                        clearInterval(_stv)
                        if (!(isFn ? context(target) : context[target])) {
                            res(false)
                        } else {
                            res(true)
                        }
                    }
                }, _interval)
            } catch (e) {
                rej(e)
            }
        })
        // wait end
    }

    /**
     * （精简优化版）
     * sleep（异步）, 如想同步请调用时使用 async/await
     * @author CHO
     * @param context 上下文
     * @param context[target] Boolean 为true放行
     * @param target String 属性名
     * @param upperLimit Number 最大等待时长，不建议超过2000ms， 限制3000ms
     * */
    static sleepWait(context, target, upperLimit = 2000) {
        return this.sleepByAsync(context, target, upperLimit)
    }
    // 一位数补0
    static add0(m) {
        return m < 10 ? '0' + m : m
    }
    // 时间戳转换为 202x-xx-xx格式
    static ganttFormat(val) {
        if(!val) {
            return
        }
        let time = new Date(val)
        let y = time.getFullYear()
        let m = time.getMonth() + 1
        let d = time.getDate()
        return y + '-' + this.add0(m) + '-' + this.add0(d)
    }
     /**
     * 对象深拷贝
     * @param obj 需要拷贝的对象
     */
     static deepCopy(obj) {
        let newObj = JSON.parse(JSON.stringify(obj))
        return newObj
    }

     static whetherShowToolTip(value, inputWidth) {
        if (value && value != '') {
            //中文匹配规则
            let simpleCNReg = /[\u4e00-\u9fa5]/g
            //数字或者空格键匹配规则
            let numberReg = /[0-9\s]/g
            //大小写英文字母匹配规则
            let englishReg = /[a-zA-Z]/g
            //匹配特殊字符
            //let specialReg = /[~`!@#$%^&*()（）{}【】|、《》<>,.\/?\\[\];:；：‘“'"_—=+-]/g;
            //匹配多少个空格
            let spaceReg = /\s/g
            let simpleCNArray = value.match(simpleCNReg)
            let length = 0
            if (simpleCNArray) {
                length += simpleCNArray.length * 12
            }
            let numberArray = value.match(numberReg)
            if (numberArray) {
                length += numberArray.length * 7
            }
            let englishArray = value.match(englishReg)
            if (englishArray) {
                length += englishArray.length * 8
            }
            return length > inputWidth
        } else {
            // console.log(false);
            return false
        }
    }

    // 判断 el-tootip是否需要展示
    static checkShowTooTip2(value,font,inputWidth,rows = 1) {
        let canvas = this.checkShowTooTip2.canvas || (this.checkShowTooTip2.canvas = document.createElement("canvas"))
        let context = canvas.getContext("2d")
        context.font = font;
        let metrics = context.measureText(value);
        if(inputWidth == undefined) {
            return metrics.width
        }
        console.log(metrics.width)
        return metrics.width < inputWidth * rows
    }
    /**时间戳转换202x-xx-xx xx:xx:xx时间格式
     * @param val
     */
    static formatDateTime(val) {
        if (!val) {
            return ''
        }
        let time = new Date(val)
        let y = time.getFullYear()
        let m = time.getMonth() + 1
        let d = time.getDate()
        return y + '-' + this.add0(m) + '-' + this.add0(d)
    }
    static format(val) {
        if(!val) return ''
        let time = new Date(val)
        let y = time.getFullYear()
        let m = time.getMonth() + 1
        let d = time.getDate()
        let h = time.getHours()
        let mm = time.getMinutes()
        let ss = time.getSeconds()
        return (
            y + '-' + this.add0(m) + '-' + this.add0(d) + ' ' + this.add0(h) + ':' + this.add0(mm) + ':' + this.add0(ss)
        )
    }
    static formatSpace(val, type='b'){
        val = (val / (1024 * 1024)).toFixed(2)
        if(val / 1024 > 1 ){
            val = (val / 1024).toFixed(2);
            if(val / 1024 > 1){
                return (val / 1024).toFixed(2) + 'TB'
            }else{
                return val + 'GB'
            }
        }else{
            return val + 'MB';
        }
    }


    /**
     * 根据prop列合并list中所有的列
     * @param row
     * @param column
     * @param rowIndex
     * @param columnIndex
     * @param tableData 表格数据源
     * @param list 需要合并的列
     * @param prop 值相同时合并,默认当前cell的prop
     * @returns {{colspan: number, rowspan: number}}
     */
    static spanMethod({row, column, rowIndex, columnIndex},tableData,list,prop) {
        prop = prop || column.property
        tableData = tableData || []
        list = list || []
        // 当前行的数据
        let cellValue = row[prop]
        // 判断只合并定义字段的列数据
        if (cellValue && list.includes(column.property)) {
            let prevRow = tableData[rowIndex - 1] //上一行数据
            let nextRow = tableData[rowIndex + 1] //下一行数据
            // 当上一行的数据等于当前行数据时，当前行单元格隐藏
            if (prevRow && prevRow[prop] === cellValue) {
                return {rowspan: 0, colspan: 0}
            } else {
                // 反之，则循环判断若下一行数据等于当前行数据，则当前行开始进行合并单元格
                let countRowspan = 1 //用于合并计数多少单元格
                while (nextRow && nextRow[prop] === cellValue) {
                    nextRow = tableData[++countRowspan + rowIndex]
                }
                if (countRowspan > 1) {
                    return {rowspan: countRowspan, colspan: 1}
                }
            }
        }
    }



    /**
     * 根据prop列合并list中所有的列
     * @param row
     * @param column
     * @param rowIndex
     * @param columnIndex
     * @param tableData 表格数据源
     * @param list 需要合并的列
     * @param prop 值相同时合并,默认当前cell的prop
     * @returns {{colspan: number, rowspan: number}}
     */
    static spanMethod({row, column, rowIndex, columnIndex},tableData,list,prop) {
        prop = prop || column.property
        tableData = tableData || []
        list = list || []
        // 当前行的数据
        let cellValue = row[prop]
        // 判断只合并定义字段的列数据
        if (cellValue && list.includes(column.property)) {
            let prevRow = tableData[rowIndex - 1] //上一行数据
            let nextRow = tableData[rowIndex + 1] //下一行数据
            // 当上一行的数据等于当前行数据时，当前行单元格隐藏
            if (prevRow && prevRow[prop] === cellValue) {
                return {rowspan: 0, colspan: 0}
            } else {
                // 反之，则循环判断若下一行数据等于当前行数据，则当前行开始进行合并单元格
                let countRowspan = 1 //用于合并计数多少单元格
                while (nextRow && nextRow[prop] === cellValue) {
                    nextRow = tableData[++countRowspan + rowIndex]
                }
                if (countRowspan > 1) {
                    return {rowspan: countRowspan, colspan: 1}
                }
            }
        }
    }

    /**
     * 搜索关键字替换
     * @param val 需要处理的文本
     * @param searchStr 被搜索的文本
     * @returns {any}
     */
    static replaceSearchContent(val,searchStr) {
        if (searchStr) {
            let Reg = new RegExp(searchStr, 'ig');
            if (val) {
                const res = val.replace(Reg, `<span style="background: rgba(237,28,22,0.1);">$&</span>`);
                return res;
            }
        } else {
            return val;
        }
    }
    /**
     * 全屏切换
     */
    static fullscreenSwitch() {
        let elem = document.documentElement;
        if (document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement || document.msFullscreenElement) {
            if (document.exitFullscreen) {
                document.exitFullscreen();
            } else if (document.mozCancelFullScreen) { // Firefox
                document.mozCancelFullScreen();
            } else if (document.webkitExitFullscreen) { // Chrome, Safari 和 Opera
                document.webkitExitFullscreen();
            } else if (document.msExitFullscreen) { // IE/Edge
                document.msExitFullscreen();
            }
        } else {
            if (elem.requestFullscreen) {
                elem.requestFullscreen();
            } else if (elem.mozRequestFullScreen) { // Firefox
                elem.mozRequestFullScreen();
            } else if (elem.webkitRequestFullscreen) { // Chrome, Safari 和 Opera
                elem.webkitRequestFullscreen();
            } else if (elem.msRequestFullscreen) { // IE/Edge
                elem.msRequestFullscreen();
            }
        }
    }
    /*将base64图片转换为文件流*/
    static getImgToBlob(base64, type =  'image/png'){
        // 假设你的Base64字符串如下
        const base64Image = base64 || "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUA...";
        // 将base64字符串转换为Blob对象
        function base64ToBlob(base64, type = 'image/png') {
            console.log(base64.split(','))
            const byteCharacters = window.atob(base64.split(',')[1]);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            return new Blob([byteArray], { type });
        }
        // 使用Blob创建文件流
        const blob = base64ToBlob(base64Image);// 创建一个文件链接（可选）
        const url = URL.createObjectURL(blob);
        return blob;
        // // 将文件流保存为文件（在浏览器中下载）
        // const a = document.createElement('a');
        // a.href = url;
        // a.download = 'output_image.png'; // 文件名
        // document.body.appendChild(a);
        // a.click();
        // document.body.removeChild(a);
        // // 释放对象URL
        // URL.revokeObjectURL(url);
    }
    static checkShowTooTipForMultiLine(e, t, i, o, n) {
        let r = this.checkShowTooTip.span || (this.checkShowTooTip.span = document.createElement("span"));
        r.style.display = "inline-block",
          r.style.visibility = "hidden",
          r.style.font = t,
          r.style.lineHeight = i + "px",
          r.innerText = e,
          document.body.appendChild(r);
        let {width: s, height: a} = r.getBoundingClientRect();
        return r.remove(),
        s < o && a / i <= n
    }
    /**
     *
     * @desc   判断是否为手机号
     * @param  {String|Number} str
     * @return {Boolean}
     */
    static isPhoneNum(str) {
        return /^(0|86|17951)?(1[3-9][0-9])[0-9]{8}$/.test(str);
    }

    /**校验当前文件的类型**/
    static checkFileNameType(fileName, type) {
        let arr = (fileName || '').split('.');
        let fileType = arr[arr.length - 1].toLowerCase();
        if (arr.length <= 1) return false;
        if (type instanceof Array) {
            let lowerType = type.map(i => {
                return i.toLowerCase()
            })
            return lowerType.includes(fileType)
        } else {
            return fileType === type.toLowerCase()
        }
    }

    /**校验当前文件是否是图片**/
    static checkFileIsPhoto(fileName) {
       return this.checkFileNameType(fileName,FILEEXT_image)
    }
    static  isMobile() {
        const userAgent = navigator.userAgent.toLowerCase();
        // 常见的移动设备标志
        const isMo =  /iphone|ipad|ipod|android|webos|blackberry|iemobile|HarmonyOS|opera mini/i.test(userAgent) ;
        const isSmallScreen = window.innerWidth <= 1024;
        return isMo || isSmallScreen;
    }
}
import router from "@/router";
import {Message} from "element-ui";

export const getInviteLink = () => {
    document.body.focus();
    const baseUrl = `${window.location.protocol}//${window.location.host}/`;
    let href = router.resolve({
        name: 'index'
    }).href
    const link = baseUrl + href + `?inviteCode=${localStorage.getItem('inviteCode')}`
    navigator.clipboard.writeText(link || '').then(() => {
        Message.success('已复制邀请链接');
    }).catch(function (err) {
        console.error('复制失败: ', err);
    });
}
